import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import Flex from 'components/ui/Flex';
import Typography from 'components/ui/Typography';
import useIntersectionObserver from 'hooks/useIntersectionObserver';
import { breakPoint, palette } from 'shared/styles';

const SectionB = () => {
  const [isIntersecting, setIsInterSecting] = useState(false);
  const isMobile = useMediaQuery({
    query: breakPoint.MOBILE,
  });
  const isTablet = useMediaQuery({
    query: breakPoint.TABLET,
  });
  const isSmallDevice = useMediaQuery({
    query: breakPoint.SMALL_DEVICE,
  });
  const target = useIntersectionObserver({
    onIntersect: setIsInterSecting,
    repeat: false,
    ...(isMobile && { threshold: 0.1 }),
  });

  return (
    <Container ref={target} isIntersecting={isIntersecting}>
      <StyledFlex direction="column" align="center" justify="center">
        <Typography.Title
          type="h1"
          align="center"
          css={css`
            white-space: pre-line;

            @media screen and ${breakPoint.MOBILE} {
              font-size: 24px;
              line-height: 34px;
            }
            @media screen and ${breakPoint.TABLET} {
              font-size: 36px;
              line-height: 46px;
            }
          `}
        >
          {`AI 기반 화장품 아트웍${isMobile ? '\n' : ' '}스크리닝 시스템`}
        </Typography.Title>
        <Typography.Title
          type="b1"
          align="center"
          color="DARK_GREY"
          css={css`
            white-space: pre-line;
            margin: 36px 0 80px;
            font-size: 16px;

            @media screen and ${breakPoint.MOBILE} {
              font-size: 14px;
              line-height: 22px;
              margin: 32px 0px 36px;
            }
            @media screen and ${breakPoint.TABLET} {
              font-size: 16px;
              line-height: 28px;
              margin: 36px 0px 80px;
            }
          `}
        >
          {`당사의 스크리닝 시스템은 화장품 Artwork 이미지에 특화된 레이아웃 분석과 OCR 기술로 텍스트를 추출한 뒤,${
            isSmallDevice ? ' ' : '\n'
          }도메인 특화 대규모 언어 모델을 활용해 필수 기재사항 누락, 문장 오류, 규제 적합성 등을 종합적으로 검토합니다.`}
        </Typography.Title>
        <Image
          src={`https://cdri.s3.ap-northeast-2.amazonaws.com/assets/${
            isMobile
              ? 'tech-b-mobile2'
              : isTablet
              ? 'tech-b-tablet2'
              : 'tech-b2'
          }.png`}
          alt="ai-diagram"
        />
      </StyledFlex>
    </Container>
  );
};

export default SectionB;

const Container = styled.section<{ isIntersecting: boolean }>`
  position: relative;
  overflow: hidden;
  height: 1204px;
  background-color: ${palette.LIGHT_GREY1};

  @media screen and ${breakPoint.LARGE_DEVICE} {
    height: auto;
  }

  span,
  img {
    opacity: 0;
    transition-property: all;
    transition-timing-function: ease-in-out;
    transition-duration: 0.5s;
    transform: translateY(50px);
  }

  ${({ isIntersecting }) =>
    isIntersecting &&
    css`
      span,
      img {
        opacity: 1;
        transform: translateY(0);
      }
      span:nth-of-type(2) {
        transition-delay: 0.3s;
      }

      img {
        transition-delay: 0.6s;
      }
    `}
`;

const StyledFlex = styled(Flex)`
  height: 100%;

  @media screen and ${breakPoint.LARGE_DEVICE} {
    padding: 120px 24px;
  }

  @media screen and ${breakPoint.MOBILE} {
    padding: 80px 24px;
  }
`;

const Image = styled.img`
  width: 1200px;

  @media screen and ${breakPoint.MOBILE} {
    margin-bottom: 80px;
  }
  @media screen and ${breakPoint.TABLET} {
    margin-bottom: 156px;
  }
  @media screen and ${breakPoint.LARGE_DEVICE} {
    width: 100%;
  }
`;
